// extracted by mini-css-extract-plugin
module.exports = {"tabs":"S25_tabs__1U9F-","active":"S25_active__vsIuj","image":"S25_image__lYA4K"};